import asianChar from './asianChar'

export default function getDisplayName(person) {
  let displayFirstName = ''
  if (person.name) {
    displayFirstName = !asianChar(person.name) ? person.name.toString() : person.name.toString()
  }
  let displayLastName = ''
  if (person.surname) {
    displayLastName = !asianChar(person.surname) ? person.surname.toString() : person.surname.toString()
  }

  const isAsian = !!(asianChar(displayFirstName) || asianChar(displayLastName))
  const displayName =
    isAsian === true ? `${displayLastName}${displayFirstName}` : `${displayFirstName} ${displayLastName}`.trim()

  return displayName
}
